import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["invoice", "propertyDefinitions", "propertyName", "displayLabel", "propertyLabelOverride", "formattedPropertyProps"];
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import { getInvoiceProperty, getPropertyDefinition } from '../utils/property';
import { useCallback } from 'react';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const alwaysUndefined = () => undefined;
const FormattedInvoicePropertyLabelAndValue = _ref => {
  let {
      invoice,
      propertyDefinitions,
      propertyName,
      displayLabel = true,
      propertyLabelOverride,
      formattedPropertyProps
    } = _ref,
    wrapperProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const maybePropertyValue = getInvoiceProperty(invoice, propertyName);
  const maybePropertyDefinition = getPropertyDefinition(propertyDefinitions, propertyName);
  const getSavedValue = useCallback(additionalPropertyname => {
    return getInvoiceProperty(invoice, additionalPropertyname);
  }, [invoice]);
  if (!maybePropertyDefinition) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TruncateString, Object.assign({
    useFlex: true
  }, wrapperProps, {
    children: [displayLabel ? /*#__PURE__*/_jsx("span", {
      children: propertyLabelOverride || `${maybePropertyDefinition.label}: `
    }) : null, /*#__PURE__*/_jsx(FormattedPropertyV2, Object.assign({}, formattedPropertyProps, {
      objectTypeId: invoice.objectTypeId,
      objectId: `${invoice.objectId}`,
      property: maybePropertyDefinition,
      value: maybePropertyValue,
      getDraftValue: alwaysUndefined,
      getSavedValue: getSavedValue
    }))]
  }));
};
export default FormattedInvoicePropertyLabelAndValue;